import React, { useState } from 'react';

const seed = [
  { city: 'LA', text: '"Lord, let Los Angeles be shaken. Let the fire of revival touch every campus, every neighborhood, every heart."', author: 'Marcus A., Los Angeles' },
  { city: 'DAL', text: '"God, raise up laborers in Dallas. Let this generation be the one that changes the spiritual atmosphere of this city."', author: 'Priscilla W., Dallas' },
  { city: 'HI', text: '"Let the islands praise Him. Let Hawaii be a beacon of His glory to the nations."', author: 'Kezia M., Honolulu' },
  { city: 'ATL', text: '"Atlanta has been asleep. Lord let REVIVE Atlanta be the alarm that wakes this generation."', author: 'David O., Atlanta' },
  { city: 'CO', text: '"From the mountains to the cities, let your Spirit sweep through Colorado. We are ready."', author: 'Sarah L., Denver' },
  { city: 'SF', text: '"San Francisco is a city of influence. Lord, let Your people reclaim it."', author: 'James T., San Francisco' },
  { city: 'LA', text: '"I prayed for years for a move of God in this city. I believe REVIVE LA is the answer."', author: 'Amara E., Riverside' },
  { city: 'DAL', text: '"Let Dallas be a city set on a hill. One night, Lord. Change everything."', author: 'Emmanuel K., Dallas' },
  { city: 'LA', text: '"Every campus in Los Angeles will know the name of Jesus after REVIVE LA."', author: 'Grace O., UCLA' },
];

export default function PrayerWall() {
  const [prayers, setPrayers] = useState(seed);
  const [form, setForm] = useState({ prayer: '', name: '', city: '', 'bot-field': '' });
  const [submitted, setSubmitted] = useState(false);
  const [paused, setPaused] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!form.prayer.trim()) return;
    const body = new URLSearchParams({ 'form-name': 'prayer', ...form });
    await fetch('/', { method: 'POST', headers: { 'Content-Type': 'application/x-www-form-urlencoded' }, body: body.toString() });
    setPrayers([{ city: form.city || 'YOU', text: `"${form.prayer}"`, author: form.name || 'Anonymous' }, ...prayers]);
    setForm({ prayer: '', name: '', city: '', 'bot-field': '' });
    setSubmitted(true);
    setTimeout(() => setSubmitted(false), 4000);
  };

  const all = [...prayers, ...prayers]; // duplicate for seamless loop

  return (
    <section id="prayer" style={{ padding: '120px 64px', background: 'var(--black)' }}>
      <style>{`
        @media(max-width:768px){ #prayer{padding:80px 24px!important;} .prayer-submit-grid{grid-template-columns:1fr!important;} }
        @keyframes prayerScroll { 0%{transform:translateY(0)} 100%{transform:translateY(-50%)} }
        .prayer-scroll { animation: prayerScroll 35s linear infinite; }
        .prayer-scroll.paused { animation-play-state: paused; }
      `}</style>

      <p className="reveal" style={{ fontSize: 10, letterSpacing: '0.35em', textTransform: 'uppercase', color: 'var(--ember)', marginBottom: 20 }}>Live Prayer Wall</p>
      <h2 className="reveal" style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(48px,6vw,80px)', lineHeight: 0.95, color: 'var(--white)', marginBottom: 24 }}>
        CITIES ARE<br />ALREADY<br />PRAYING
      </h2>
      <div className="reveal" style={{ width: 48, height: 3, background: 'linear-gradient(90deg,var(--ember),var(--gold))', margin: '0 0 24px' }} />
      <p className="reveal" style={{ fontFamily: 'var(--font-serif)', fontSize: 18, lineHeight: 1.75, color: 'rgba(245,240,232,0.55)', maxWidth: 520, marginBottom: 56 }}>
        Before REVIVE arrives, your city is already on its knees. Submit your prayer — it joins the wall displayed at the event.
      </p>

      {/* Prayer wall */}
      <div className="reveal" style={{ border: '1px solid rgba(200,68,10,0.15)', height: 380, overflow: 'hidden', position: 'relative' }}
        onMouseEnter={() => setPaused(true)} onMouseLeave={() => setPaused(false)}>
        <div style={{ position: 'absolute', top: 0, left: 0, right: 0, height: 60, background: 'linear-gradient(180deg, var(--black), transparent)', zIndex: 2, pointerEvents: 'none' }} />
        <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 60, background: 'linear-gradient(0deg, var(--black), transparent)', zIndex: 2, pointerEvents: 'none' }} />
        <div className={`prayer-scroll${paused ? ' paused' : ''}`}>
          {all.map((p, i) => (
            <div key={i} style={{ padding: '20px 28px', borderBottom: '1px solid rgba(200,68,10,0.08)', display: 'flex', gap: 24, alignItems: 'flex-start' }}>
              <div style={{ fontFamily: 'var(--font-display)', fontSize: 14, letterSpacing: '0.15em', color: 'var(--ember)', whiteSpace: 'nowrap', minWidth: 48, paddingTop: 2 }}>{p.city}</div>
              <div>
                <div style={{ fontFamily: 'var(--font-serif)', fontStyle: 'italic', fontSize: 16, color: 'rgba(245,240,232,0.65)', lineHeight: 1.65 }}>{p.text}</div>
                <div style={{ fontSize: 11, letterSpacing: '0.12em', color: 'rgba(245,240,232,0.28)', marginTop: 6 }}>— {p.author}</div>
              </div>
            </div>
          ))}
        </div>
      </div>

      {/* Submit form */}
      <form onSubmit={handleSubmit} name="prayer" data-netlify="true" netlify-honeypot="bot-field" style={{ marginTop: 40 }}>
        <input type="hidden" name="form-name" value="prayer" />
        <input type="hidden" name="bot-field" value={form['bot-field']} />
        <div className="prayer-submit-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr auto', gap: 12 }}>
          <input required placeholder="Your prayer for your city..." value={form.prayer} onChange={e => setForm({ ...form, prayer: e.target.value })}
            style={{ background: 'rgba(8,8,8,0.5)', border: '1px solid rgba(245,240,232,0.12)', color: 'var(--white)', padding: '14px 16px', fontFamily: 'var(--font-body)', fontSize: 14, outline: 'none', gridColumn: '1 / span 2' }} />
          <select value={form.city} onChange={e => setForm({ ...form, city: e.target.value })}
            style={{ background: 'rgba(8,8,8,0.8)', border: '1px solid rgba(245,240,232,0.12)', color: form.city ? 'var(--white)' : 'rgba(245,240,232,0.4)', padding: '14px 16px', fontFamily: 'var(--font-body)', fontSize: 13, outline: 'none', appearance: 'none' }}>
            <option value="">Your City</option>
            {[['LA','Los Angeles'],['DAL','Dallas'],['SF','San Francisco'],['HI','Hawaii'],['LA','Louisiana'],['CO','Colorado'],['ATL','Atlanta']].map(([short, full]) => <option key={full} value={short}>{full}</option>)}
          </select>
          <button type="submit"
            style={{ background: 'var(--ember)', color: 'var(--white)', border: 'none', padding: '14px 28px', fontFamily: 'var(--font-body)', fontSize: 12, fontWeight: 500, letterSpacing: '0.2em', textTransform: 'uppercase', whiteSpace: 'nowrap' }}
            onMouseEnter={e => e.target.style.background = 'var(--ember-light)'}
            onMouseLeave={e => e.target.style.background = 'var(--ember)'}>
            Add Prayer →
          </button>
        </div>
        {submitted && <p style={{ marginTop: 12, fontSize: 13, color: 'var(--gold)', fontFamily: 'var(--font-serif)', fontStyle: 'italic' }}>Your prayer has been added. Heaven hears it.</p>}
      </form>
    </section>
  );
}
